import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-googlechat',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Google Chat icon</title><path d="M7.533 0a1.816 1.816 0 0 0-1.816 1.816v2.832h11.178c1.043 0 1.888.855 1.888 1.91v8.204h2.906a1.816 1.816 0 0 0 1.817-1.817V1.816A1.816 1.816 0 0 0 21.689 0H7.533zM2.311 5.148A1.816 1.816 0 0 0 .494 6.965V23.09c0 .81.979 1.215 1.55.642l3.749-3.748h10.674a1.816 1.816 0 0 0 1.816-1.816V6.965a1.816 1.816 0 0 0-1.816-1.817H2.31Z"/></svg>`,
    styles: []
})
export class SimpleIconsGooglechatComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#00AC47';
    @Input() className: string = 'simple-icons-googlechat'
    constructor() {}
    ngOnInit(): void {}
}
